/**
 * Email API Service
 * Handles all email-related API calls
 */

import api from './api';
import { EmailSettings, EmailSettingsFormData, SentEmailsResponse } from '../types/email.types';

export const emailService = {
  /**
   * Get current email settings
   */
  getSettings: async (): Promise<EmailSettings | null> => {
    const response = await api.get('/admin/email-settings');
    return response.data.settings;
  },

  /**
   * Save or update email settings
   */
  saveSettings: async (data: EmailSettingsFormData): Promise<EmailSettings> => {
    const response = await api.post('/admin/email-settings', data);
    return response.data.settings;
  },

  /**
   * Test email connection by sending test email
   */
  testConnection: async (): Promise<{ success: boolean; message: string }> => {
    const response = await api.post('/admin/email-settings/test');
    return response.data;
  },

  /**
   * Send thank you email for a meeting
   */
  sendThankYou: async (meetingId: number): Promise<{ success: boolean; message: string; messageId?: string }> => {
    const response = await api.post(`/meetings/${meetingId}/send-thank-you`);
    return response.data;
  },

  /**
   * Get email sending history with pagination
   */
  getSentEmails: async (page = 1, limit = 20): Promise<SentEmailsResponse> => {
    const response = await api.get(`/admin/sent-emails?page=${page}&limit=${limit}`);
    return response.data;
  }
};
